import { Lookup } from '../lookup.interface';
export const PreInterventionEmploymentTypes: { [name: string]: Lookup } = {
  employed: { displayValue: 'Employed' },
  unemployed: { displayValue: 'Unemployed' },
  selfEmployed: { displayValue: 'Self-Employed' },
  notInLabourForce: { displayValue: 'Not in Labour Force' },
};
